import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';

import { ErrorWithText } from '@models/vragenboom';
import { ApplicationInsightsService } from '@crosscutting/public_api';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class WafInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const wafError = error.error as ErrorWithText;
        const _applicationInsightsService = this.injector.get(ApplicationInsightsService);

        if (wafError && wafError.text) {
          const matches = wafError.text.match('Your support ID is: (\\d+)');
          if (matches?.length > 1) {
            _applicationInsightsService.logErrorWithMessage(`Support Id: ${matches[1]}`, 'Waf Interception', SeverityLevel.Error);
          }
        }
        return throwError(error);
      })
    );
  }
}
